export default function getAge(date) {
    return new Date(new Date() - new Date(date)).getFullYear() - 1970
}